import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useDocument } from "../../../../hooks/query";
import { API_ENDPOINTS } from "../../../../constants";

export default function useInitialInspection() {
    const { id: projectId } = useParams();
    const { useList } = useDocument();
    const listDocListSvc = useList();

    const [inspectionDocument, setInspectionDocument] = useState<any | null>(null);

    const getDocumentStatus = async () => {
        try {
            if (!projectId) {
                return;
            }
            const response = await listDocListSvc.mutateAsync({ ProjectId: projectId });
            const doc = response.find((document: any) => document.Name === "INITIAL_INSPECTION");
            
            if (doc) {
                const imageUrl = API_ENDPOINTS.asset.getImageAsSrc(doc.ThumbnailAssetId);
                doc.thumbnailUrl = imageUrl;
            }
            setInspectionDocument(doc);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getDocumentStatus().then();
    }, [projectId]);

    return {
        inspectionDocument,
        refreshInspection: getDocumentStatus,
    };
}
